/* Components */
import { getLayout } from '@components/PageLayouts/Layout/Standard';
import IframeView from '@components/IframeView';
import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';

function ContactUsPage(props: any) {
  return (
    <>
      <Head>{generateNextSeo({ title: 'Contact HelloTech' })}</Head>
      <IframeView callerPageName="faq" src="https://latch.formstack.com/forms/contact_us" />
    </>
  );
}

ContactUsPage.pageAttributes = { page: 'Contact-Us' };
ContactUsPage.Layout = getLayout({ promo: true, footer: true, chat: false });

export default ContactUsPage;
